import theme from '@/assets/vendor/echarts-theme.json'
import { PieChart, LineChart, BarChart } from 'echarts/charts'
import {
  GridComponent,
  LegendComponent,
  LegendScrollComponent,
  TooltipComponent,
  MarkLineComponent,
  MarkAreaComponent,
  MarkPointComponent,
  DataZoomComponent,
} from 'echarts/components'
import { use, registerTheme } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import ECharts from 'vue-echarts'

registerTheme('cycloid', theme)
use([
  CanvasRenderer,
  PieChart,
  LineChart,
  BarChart,
  GridComponent,
  LegendComponent,
  LegendScrollComponent,
  TooltipComponent,
  MarkLineComponent,
  MarkAreaComponent,
  MarkPointComponent,
  DataZoomComponent,
])

export default {
  /** @param {import('vue').App} app - The Vue instance. */
  install (app) {
    app.component('ECharts', ECharts)
  },
}
